import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import * as PermissionActions from './permission.actions';
import * as PermissionSelectors from './permission.selectors';
import type { Profile } from '../../models/profile';

@Injectable({
  providedIn: 'root',
})
export class PermissionFacadeService {
  store = inject(Store);

  userProfile$: Observable<Profile> = this.store.select(PermissionSelectors.selectUserProfile);
  loading$: Observable<boolean> = this.store.select(PermissionSelectors.selectLoading);
  error$: Observable<string | null> = this.store.select(PermissionSelectors.selectError);

  constructor() {}

  loadUserProfile(): void {
    this.store.dispatch(PermissionActions.loadUserProfile());
  }

  setPermission(profile: Profile): void {
    this.store.dispatch(PermissionActions.setUserProfile({ profile }));
  }
}
